import { Component, OnInit, Inject, AfterViewInit, AfterContentInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'jt-server-error-dialog',
	templateUrl: './server-error-dialog.component.html',
	styleUrls: ['./server-error-dialog.component.scss']
})
export class ServerErrorDialogComponent implements AfterContentInit {

	errorResponse: HttpErrorResponse | any;
	errorData: HttpErrorResponse | any;
	visible: boolean = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		public dialogRef: MatDialogRef<ServerErrorDialogComponent>) {
	}

	ngAfterContentInit() {
		this.errorResponse = this.data.errorResponse;
	}

}
